import * as React from 'react';
import { classes, style } from 'typestyle';
import { Black, GrayDark, White } from '../../../styles/colors';
import { mediumStyle, smallStyle } from '../../..';
const WindowHeader = ({ className, title, whiteBackground, rightIcon, leftIcon, subTitle, }) => {
    return (React.createElement("div", { className: classes('tds-window-header', headerStyle, whiteBackground ? whiteBgStyle : '', className) },
        React.createElement("div", { className: classes('tds-window-header-left-icon', iconStyle, leftIconStyle) }, leftIcon),
        React.createElement("div", { className: classes('tds-window-header-title-container', titleContainerStyle, whiteBackground ? blackColorScheme : whiteColorScheme) },
            React.createElement("div", { className: classes('tds-window-header-title', titleStyle, mediumStyle) }, title),
            React.createElement("div", { className: classes('tds-window-header-subtitle', subTitleStyle, smallStyle) }, subTitle)),
        React.createElement("div", { className: classes('tds-window-header-right-icon', iconStyle, rightIconStyle) }, rightIcon)));
};
export default WindowHeader;
const titleContainerStyle = style({
    padding: '4px 0px',
    flexGrow: 1,
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
});
const subTitleStyle = style({
    textAlign: 'center',
});
const blackColorScheme = style({
    $nest: {
        '.tds-window-header-title': {
            color: Black,
        },
        '.tds-window-header-subtitle': {
            color: GrayDark,
        },
    },
});
const whiteColorScheme = style({
    $nest: {
        '.tds-window-header-title': {
            color: White,
        },
        '.tds-window-header-subtitle': {
            color: White,
        },
    },
});
const headerStyle = style({
    display: 'flex',
    background: Black,
    padding: '0 8px',
    alignItems: 'flex-start',
    minHeight: 40,
});
const whiteBgStyle = style({
    background: `${White} !important`,
});
const iconStyle = style({
    display: 'flex',
    minWidth: 24,
    padding: '8px 0',
});
const leftIconStyle = style({
    marginRight: 4,
});
const rightIconStyle = style({
    marginLeft: 4,
});
const titleStyle = style({
    flexGrow: 1,
    textAlign: 'center',
});
//# sourceMappingURL=WindowHeader.js.map